/**
 * ChannelBadge — Badge che mostra il canale di un ordine.
 * Se è un partner/reseller, mostra il nome del partner.
 * Se è diretto, mostra "Diretto".
 *
 * Props:
 *   - channelType:  'DIRETTO' | 'RESELLER' | 'ASSOCIAZIONE' | string
 *   - resellerInfo: { nome_mssp, codice_referral } | null
 *   - size:         'sm' | 'md' (default 'sm')
 */
import React from 'react';

const CHANNEL_STYLES = {
  DIRETTO:       { bg: 'bg-gray-100',   text: 'text-gray-700',   label: 'Diretto' },
  RESELLER:      { bg: 'bg-blue-100',   text: 'text-blue-700',   label: 'Reseller' },
  ASSOCIAZIONE:  { bg: 'bg-purple-100', text: 'text-purple-700', label: 'Associazione' },
};

const SIZE_CLASSES = {
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-3 py-1',
};

export default function ChannelBadge({ channelType, resellerInfo, size = 'sm' }) {
  if (!channelType) return <span className="text-gray-400 text-xs">—</span>;

  const style = CHANNEL_STYLES[channelType] || {
    bg: 'bg-gray-100',
    text: 'text-gray-600',
    label: channelType,
  };

  // Se è un partner/reseller e abbiamo il nome, mostriamo quello
  const label = resellerInfo?.nome_mssp || style.label;

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium whitespace-nowrap ${style.bg} ${style.text} ${SIZE_CLASSES[size] || SIZE_CLASSES.sm}`}
      title={resellerInfo?.codice_referral || ''}
    >
      {label}
    </span>
  );
}
